import { TContactType } from '@cian/contact-card-component';
import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { AgentInfo, MoreOffers } from '../../../../components/BottomAuthorBlockNew';
import { CardSectionNew } from '../../../../components/CardSectionNew';
import {
  offerSelector,
  selectAgentName,
  selectIsAgencyBrandingAvailable,
  selectIsByHomeowner,
  selectOfferAgent,
} from '../../../../selectors';
import { getIsFromBuilder } from '../../../../selectors/newObject';
import { selectAgentAvatarUrl, selectAgentUrl, selectIsSubAgent } from '../../../../selectors/offerData/agent';
import { getAuthorLabelV2 } from '../../../../utils/agent';
import { showCountrysideBuilderBadge } from '../../../../utils/suburban';
import { PhonesContainer } from '../../../AsideContacts/PhonesContainer';
import { CallBackButtonContainer } from '../../../CallBackButton';
import {
  AgentHonestContainer,
  AgentLifeTimeContainer,
  AgentProofsTitleContainer,
  AgentReviewsTitleContainer,
} from './parts';

export const AgentInfoContainer: React.FC = () => {
  const isByHomeowner = useSelector(selectIsByHomeowner);
  const isFromBuilder = useSelector(getIsFromBuilder);
  const isShowCountrysideBuilderBadge = useSelector(showCountrysideBuilderBadge);
  const isBrandingAvailable = useSelector(selectIsAgencyBrandingAvailable);

  const offer = useSelector(offerSelector);
  const agent = useSelector(selectOfferAgent, shallowEqual);

  const agentName = useSelector(selectAgentName);
  const agentLink = useSelector(selectAgentUrl);
  const avatar = useSelector(selectAgentAvatarUrl);

  const isSubAgent = useSelector(selectIsSubAgent);
  const avatarType: TContactType = isSubAgent ? 'agent' : 'agency';

  const title = agent && getAuthorLabelV2(offer, agent, isShowCountrysideBuilderBadge);

  if (!agent || isByHomeowner || isBrandingAvailable || isFromBuilder) {
    return null;
  }

  return (
    <CardSectionNew>
      <AgentInfo
        avatarType={avatarType}
        avatar={avatar}
        title={title}
        agentLink={agentLink}
        agentName={agentName}
        agentHonest={<AgentHonestContainer />}
        agentReviews={<AgentReviewsTitleContainer />}
        agentProofs={<AgentProofsTitleContainer />}
        contactButton={<PhonesContainer size="XS" />}
        callButton={<CallBackButtonContainer size="XS" placeType="agent_block" />}
        lifeTime={<AgentLifeTimeContainer />}
        linkToMoreOffers={<MoreOffers offersLink={agent.offersLink} offersCount={agent.offersCount} />}
      />
    </CardSectionNew>
  );
};
